import { adminRoutes } from '@onov/contracts';
import { ApiClientError, createClient } from '@onov/api-client';
import { useAuthStore } from './auth-store.js';

const BASE_URL = (import.meta.env.VITE_API_URL as string | undefined) ?? 'http://localhost:3000';

/**
 * Typed admin client (ADR-20). Every response is parsed against the contract,
 * so a drifted server fails loudly here rather than rendering wrong data in a
 * moderation queue.
 */
export const api = createClient(
  { admin: adminRoutes },
  {
    baseUrl: BASE_URL,
    getToken: () => useAuthStore.getState().token,
    onUnauthorized: async () => {
      useAuthStore.getState().signOut();
      return false;
    },
  },
);

export { ApiClientError };
export const isForbidden = (e: unknown): boolean =>
  e instanceof ApiClientError && e.kind === 'http' && e.status === 403;
export const errorMessage = (e: unknown): string => {
  if (e instanceof ApiClientError) {
    try {
      const j = JSON.parse(e.message) as { message?: string };
      if (j.message) return j.message;
    } catch {
      /* plain text */
    }
    return e.message;
  }
  return e instanceof Error ? e.message : 'Something went wrong';
};
